import {EventEmitter, Injectable} from '@angular/core';
import {Config} from '../services/env.config';
import {HttpClient, HttpHeaders, HttpRequest} from '@angular/common/http';
import {Subject, Subscription} from 'rxjs';
import { Router } from '@angular/router';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})

export class ReportsService {
    
  constructor(private http: HttpClient, private router: Router) { }
    cpHeaders = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Content-Security-Policy': 'default-src \'self\'; script-src \'self\'; style-src \'self\' \'unsafe-inline\'',
      'Strict-Transport-Security': 'max-age=31536000; includeSubDomains; preload',
      'X-Frame-Options': 'DENY',
      'X-Content-Type-Options': 'nosniff',
      'Referrer-Policy': 'strict-origin-when-cross-origin',
      'Permissions-Policy': 'geolocation=(self), camera=(self),microphone=(self),payment=(self),usb=(self),accelerometer=(self)'
        })
      };

      getFinancialYear() {
        let data = JSON.parse(sessionStorage.getItem('user'));
        let user = { Userid : data.UserName }; 
        return this.http.post(Config.BaseEndpoint + '/LoadFinancialYear', JSON.stringify(user), this.cpHeaders)
          .toPromise()
          .then((response: any) => {
            return response;
          })
          .catch((error) => {
            return Promise.reject(error);
          });
      }

      getReportee() {
        let data = JSON.parse(sessionStorage.getItem('user'));
        let user = { UserName : data.UserName }; 
        return this.http.post(Config.BaseEndpoint + '/GetReportee', JSON.stringify(user), this.cpHeaders)
          .toPromise()
          .then((response: any) => {
            return response;
          })
          .catch((error) => {
            return Promise.reject(error);
          });
      }

      getReports(year, reportee) {
        let data = JSON.parse(sessionStorage.getItem('user'));
        if(reportee == '--Select--') {
          reportee = "";
        }
        let user = { UserName : data.UserName  ,FinYear : year, DealUserName  : reportee}; 
        return this.http.post(Config.BaseEndpoint + '/GetSalesReport', JSON.stringify(user), this.cpHeaders)
          .toPromise()
          .then((response: any) => {
            return response;
          })
          .catch((error) => {
            return Promise.reject(error);
          });
      }
      getProcessReports(desigId, fromdate, toDate, region, rs ) {
        let data = JSON.parse(sessionStorage.getItem('user'));
      fromdate =  moment(fromdate).format('DD/MM/YYYY');
      toDate =  moment(toDate).format('DD/MM/YYYY');
        let user = { UserName : data.UserName , Region : region, RSCode: rs, FromDate: fromdate, ToDate: toDate, DesigId: desigId}; 
        return this.http.post(Config.BaseEndpoint + '/GetOrderVsInvoiced', JSON.stringify(user), this.cpHeaders)
          .toPromise()
          .then((response: any) => {
            return response;
          })
          .catch((error) => {
            return Promise.reject(error);
          });
      } 
    
      public export_Table_excels(desigId, fromdate, toDate, region, rs ) {
        let data = JSON.parse(sessionStorage.getItem('user'));
      fromdate =  moment(fromdate).format('DD/MM/YYYY');
      toDate =  moment(toDate).format('DD/MM/YYYY');
        let user = { UserName : data.UserName , Region : region, RSCode: rs, FromDate: fromdate, ToDate: toDate, DesigId: desigId}; 
        return this.http
        .post(Config.BaseEndpoint + '/ExcelOrderInv', JSON.stringify(user)  , {  headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }) })
        .toPromise()
        .then((response: any) => {
          return response;
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    
      }

      getRs(region) {
        let data = JSON.parse(sessionStorage.getItem('user'));
        let user = { UserName : data.UserName , Region: region}; 
        return this.http.post(Config.BaseEndpoint + '/GetRs', JSON.stringify(user), this.cpHeaders)
          .toPromise()
          .then((response: any) => {
            return response;
          })
          .catch((error) => {
            return Promise.reject(error);
          });
      }

      getRegion() {
        let data = JSON.parse(sessionStorage.getItem('user'));
        let user = { UserName : data.UserName }; 
        return this.http.post(Config.BaseEndpoint + '/GetRegionList', JSON.stringify(user), this.cpHeaders)
          .toPromise()
          .then((response: any) => {
            return response;
          })
          .catch((error) => {
            return Promise.reject(error);
          });
      }
      
      getDashboardReport(fromDate, toDate, region) {
        fromDate = moment(fromDate).format('DD-MM-YYYY');
        toDate = moment(toDate).format('DD-MM-YYYY');
        let data = JSON.parse(sessionStorage.getItem('user'));
        let user = { UserName : data.UserName , Region: region, FromDate: fromDate, ToDate: toDate,RepType: ''}; 
        return this.http.post(Config.BaseEndpoint + '/GetOrderProcessed', JSON.stringify(user), this.cpHeaders)
          .toPromise()
          .then((response: any) => {
            return response;
          })
          .catch((error) => {
            return Promise.reject(error);
          });
      }
      getDashboardReportABM(fromDate, toDate) {
        fromDate = moment(fromDate).format('DD-MM-YYYY');
        toDate = moment(toDate).format('DD-MM-YYYY');
        let data = JSON.parse(sessionStorage.getItem('user'));
        let user = { UserName : data.UserName ,  FromDate: fromDate, ToDate: toDate,RepType: ''}; 
        return this.http.post(Config.BaseEndpoint + '/GetOrderProcessed', JSON.stringify(user), this.cpHeaders)
          .toPromise()
          .then((response: any) => {
            return response;
          })
          .catch((error) => {
            return Promise.reject(error);
          });
      }
      public export_dashboard_report(fromDate, toDate, region) {
        fromDate = moment(fromDate).format('DD-MM-YYYY');
        toDate = moment(toDate).format('DD-MM-YYYY');
        let data = JSON.parse(sessionStorage.getItem('user'));
        let user = { UserName : data.UserName , Region: region, FromDate: fromDate, ToDate: toDate,RepType: ''};  
        return this.http
        .post(Config.BaseEndpoint + '/ExcelOrderProcessed', JSON.stringify(user)  , {  headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }) })
        .toPromise()
        .then((response: any) => {
          return response;
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    
      }
      public export_dashboard_abm(fromDate, toDate) {
        fromDate = moment(fromDate).format('DD-MM-YYYY');
        toDate = moment(toDate).format('DD-MM-YYYY');
        let data = JSON.parse(sessionStorage.getItem('user'));
        let user = { UserName : data.UserName ,  FromDate: fromDate, ToDate: toDate,RepType: ''};  
        return this.http
        .post(Config.BaseEndpoint + '/ExcelOrderProcessed', JSON.stringify(user)  , {  headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        }) })
        .toPromise()
        .then((response: any) => {
          return response;
        })
        .catch((error) => {
          return Promise.reject(error);
        });
    
      }

  public export_Table(year, reportee) {
    let data = JSON.parse(sessionStorage.getItem('user'));
    if(reportee == '--Select--') {
      reportee = "";
    }
        let user = { UserName : data.UserName  ,FinYear : year, DealUserName  : reportee};
    return this.http
    .post(Config.BaseEndpoint + '/ExcelReport', JSON.stringify(user)  , {  headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    }) })
    .toPromise()
    .then((response: any) => {
      return response;
    })
    .catch((error) => {
      return Promise.reject(error);
    });

  }


    
}
